@if (heatmap) {
    <div class="container">
        <div class="d-flex gap-10 align-items-start pl-8 mb-10">
            <mat-icon class="pollIcon" color="accent">scatter_plot</mat-icon>
            <div>
                <h3 class="my-0">{{ heatmap.title }}</h3>
                <div class="italic">{{ heatmap.description }}</div>
                @if (heatmap.end_at) {
                    <div>
                        <small style="color: var(--accent)">* This survey
                            @if (!hasTimePassed) {
                                will close
                            }
                            @if (hasTimePassed) {
                                closed
                            }
                            {{ heatmap.end_at | relativeTime }}</small>
                    </div>
                }
                @if (!hasTimePassed) {
                    <div>
                        <small style="color: var(--accent)">You have {{ remainingVotes > 0 ? remainingVotes : 'no' }}
                            remaining
                            votes</small>
                    </div>
                }
            </div>
        </div>
        <app-heatmap
            #heatmapComponent='heatmap'
            (click)="remainingVotes <= 0 && (isSuperuser || hasCommunityRole(['member'])) && !preview && openVoteOverlay()"
            (onClick)="openVoteOverlay($event)"
            [class.noCursorEvents]="hasTimePassed || !(isSuperuser || hasCommunityRole(['member'])) || remainingVotes <= 0"
            [clickData]="userClickData"
            [disableVotes]="hasTimePassed || !(isSuperuser || hasCommunityRole(['member'])) || remainingVotes <= 0"
            [img]="heatmap.image"
            [singleClick]="true"
            [strictPoints]="true"
        ></app-heatmap>
        <div [class.opened]="overlayOpened" class="vote-overlay">
            <mat-card [formGroup]="voteForm">
                <mat-card-content class="vote-container">
                    <div class="vote-content">
                        @if (readonly) {
                            <p>You have already submitted a response to this post or the voting time has
                                passed.</p>
                        }
                        <mat-radio-group [formControl]="optionFormControl" class="flex-col gap-5" color="accent">
                            @for (option of heatmap.options; track option) {
                                <div class="flex-col gap-5">
                                    <ng-container [ngTemplateOutletContext]="{ option }"
                                                  [ngTemplateOutlet]="radioOption"></ng-container>
                                </div>
                            }
                        </mat-radio-group>
                        <mat-form-field [class.gjs-no-pointer-events]="readonly" appearance="outline"
                                        class="w-100 mt-20" color="accent">
                            <mat-label>Comments</mat-label>
                            <textarea [disabled]="readonly" [readonly]="readonly"
                                      formControlName="comment"
                                      matInput maxlength="400" rows="3"></textarea>
                        </mat-form-field>
                    </div>
                </mat-card-content>
                <mat-card-footer class="pt-10">
                    <div class="vote-actions w-100 d-flex flex-space-around pb-15">
                        <button (click)="closeVoteOverlay(); heatmapComponent.resetHeatmapData()" color="warn"
                                mat-raised-button>
                            @if (!readonly) {
                                Cancel
                            }
                            @if (readonly) {
                                Close
                            }
                        </button>
                        @if (!readonly) {
                            <button (click)="vote()"
                                    [disabled]="voteForm.invalid || readonly"
                                    color="primary"
                                    mat-raised-button>
                                {{ voteButtonLabel }}
                                @if (loading) {
                                    <mat-icon>
                                        <mat-spinner color="accent"></mat-spinner>
                                    </mat-icon>
                                }
                            </button>
                        }
                    </div>
                </mat-card-footer>
            </mat-card>
        </div>
    </div>
}

<ng-template #radioOption let-option="option">
    <div (click)="setResult(option.id)" [class.readonly]="readonly"
         [ngClass]="{'selected': optionFormControl.value === option.id}"
         class="radio-line">
        <div [style.background-color]="option.color" class="color"></div>
        <mat-radio-button [checked]="optionFormControl.value === option.id" [disableRipple]="true" [value]="option.id"
                          color="accent" name="heatmapOption">
            {{ option.text }}
        </mat-radio-button>
    </div>

</ng-template>
